import {useEffect} from 'react';
import {API} from './apiClient';
import {notifyDataChanged} from './dataChanges';

export function useWorkspaceEvents(enabled){
  useEffect(()=>{
    if(!enabled||typeof EventSource==='undefined')return;
    let stream=null,stopped=false,retry=null,failures=0;
    const status=state=>window.dispatchEvent(new CustomEvent('acai-live-status',{detail:{state}}));
    const close=()=>{if(stream){stream.close();stream=null;}if(retry){clearTimeout(retry);retry=null;}};
    const connect=()=>{
      close();if(stopped||document.visibilityState==='hidden')return;
      stream=new EventSource(`${API}/workspace/events`,{withCredentials:true});
      stream.onmessage=event=>{
        try{const value=JSON.parse(event.data);
          if(value.access_lost===true){stopped=true;close();window.dispatchEvent(new Event('acai-session-expired'));return;}
          if(!Array.isArray(value.resources)||value.resources.length>3||!value.resources.every(name=>['emails','collaboration','notifications'].includes(name)))return;
          failures=0;status('connected');notifyDataChanged([...new Set(value.resources)]);
        }catch{/* No data or actions are accepted from malformed stream events. */}
      };
      stream.onerror=()=>{
        close();failures++;
        status(failures<5?'reconnecting':'disconnected');
        // Authentication/configuration failures must not create an endless fast
        // request loop. Visibility regain or remount permits another attempt.
        if(failures<5&&!stopped)retry=setTimeout(connect,Math.min(30000,2000*2**failures));
      };
    };
    const visibility=()=>{if(document.visibilityState==='hidden')close();else{failures=0;connect();}};
    const retryNow=()=>{failures=0;status('reconnecting');connect();};
    window.addEventListener('acai-live-retry',retryNow);
    document.addEventListener('visibilitychange',visibility);connect();
    return()=>{stopped=true;document.removeEventListener('visibilitychange',visibility);window.removeEventListener('acai-live-retry',retryNow);close();};
  },[enabled]);
}
